import React from "react";
import styles from "./SimpleErrorMessage.module.css";

interface Props {
  children: string;
}

export const SimpleErrorMessage: React.FC<React.PropsWithChildren<Props>> = ({
  children,
}) => {
  return <p className={styles.errorMessage}>{children}</p>;
};
